import * as moment from 'moment';
import { isEmpty, cloneDeep, groupBy } from 'lodash';
import { environment } from '../../environments/environment';
import { FormFields } from '@eview/core/domain/filters/filterCriteria';
import { FormAttributeType, FormAttributeInput } from '@eview/core/domain/form/form-attribute';
import { PostHelpers } from '@eview/core/domain/post/post.helpers';
import {
  PostStatus,
  PostPriority,
  PostFilters,
  RiskFilters,
  FormFilters,
  FilterItem
} from '@eview/core/domain/post/post';

const GetStartEndDates = (options: Object) => {
  let startDate, endDate, dateFormat = environment.format.mdY;

  endDate = moment(new Date()).format(dateFormat);
  options['duration'] = (options['startDate'] !== undefined || options['endDate'] !== undefined) ? 4 : options['duration'];
  switch (parseInt(options['duration'])) {
    case 1:
      startDate = moment(new Date()).subtract('1', 'day').format(dateFormat);
      endDate = moment(new Date()).subtract('1', 'day').format(dateFormat);
      break;
    case 2:
      startDate = moment(new Date())
        .subtract('7', 'days').format(dateFormat);
      endDate = moment(new Date()).subtract('1', 'day').format(dateFormat);
      break;
    case 3:
      startDate = moment(new Date())
        .subtract('30', 'days').format(dateFormat);
       endDate = moment(new Date()).subtract('1', 'day').format(dateFormat);
      break;
    case 4:
      let fromDate = options['fromdate']
        ? options['fromdate']
        : options['startDate'];
      let todate = options['todate'] ? options['todate'] : options['endDate'];

      if (fromDate) {
        startDate = GetDateFromObject(fromDate);
      }
      if (todate) {
        endDate = GetDateFromObject(todate);
      }
      break;
      default:
        startDate = moment(new Date()).format();
        endDate = moment(new Date()).format();
  }
  return { startdate: startDate, enddate: endDate };
};

const CreateMetaData = (infoData: any, configFilters: object) => {
  if (!infoData) {
    return '';
  }
  const config = configFilters['config'];
  const formAttributes = configFilters['formAttributes'];

  const durationType = cloneDeep(
    config[1].values.filter(item => {
      return item.id == infoData['duration'];
    })
  );
  // get region of management level is regional
  const mgmtLabel = config[0].values.filter(ele => {
    return ele.id == infoData.management_level;
  });
  const region = infoData['region'] ? infoData['region'] + ' - ' : '';
  const firstPart = mgmtLabel[0].name + ' : ' + region.toUpperCase();
  // check type category selected
  const category = formAttributes.results.filter(item => {
    return item.key === infoData['category'];
  });
  const secondPart =
    category[0] && category[0].label ? category[0].label + ' ' : '';
  // Format custom date to show range
  if (parseInt(infoData['duration']) === 4) {
    const startDate = moment(
      new Date(
        infoData.startDate.year +
          '-' +
          infoData.startDate.month +
          '-' +
          infoData.startDate.day
      )
    ).format(environment.format.date);
    const endDate = moment(
      new Date(
        infoData.endDate.year +
          '-' +
          infoData.endDate.month +
          '-' +
          infoData.endDate.day
      )
    ).format(environment.format.date);
    durationType[0].name = startDate + ' - ' + endDate;
  }
  const thirdPart = durationType[0] ? '(' + durationType[0].name + ')' : '';
  return {'title' : firstPart + secondPart + thirdPart, 'category': secondPart};
};

const CreateGraph = (data: any, type: number) => {
  if (type === 2 || type === 4) {
    const reportData = data.map(record => {
      if (record) {
        return {
          name: record.label,
          value: record.total
        };
      }
    });
    return reportData;
  } else if (type === 3) {
    let processedData: any = [];
    let temp = groupBy(data, 'label');
    if (!isEmpty(temp)) {
      Object.keys(temp).forEach(record => {
        let series: object[] = [];
        temp[record].map(rec => {
          series.push({
            value: rec.total,
            name: moment(new Date(rec.time_label * 1000))
          });
        });
        processedData.push({ name: record, series: series });
      });
    }
    return processedData;
  }
};

const GetFormattedMapData = (posts): any => {
    const regionDataGroup = groupBy(posts.results, 'mgmt_lev_1');
    const zoneDataGroup = groupBy(posts.results, 'mgmt_lev_2');
    let regionGroup = [],
      zoneGroup = [];
    for (let area in regionDataGroup) {
      regionGroup.push({ name: area, count: regionDataGroup[area].length });
    }
    for (let area in zoneDataGroup) {
      zoneGroup.push({ name: area, count: zoneDataGroup[area].length });
    }
    return [zoneGroup, regionGroup];
};

const GetPostRequestOptions = (criteria: any) => {
  let options;
  const dates = GetStartEndDates(criteria);
  options = {
    startDate: dates.startdate,
    endDate: dates.enddate,
    formId: (criteria) ? criteria.formId : environment.form.id
  };
  return options;
};

const CreateTable = (data: any) => {
  if (data.length > 0) {
    const reportData = data.map(record => {
      if (record) {
        return {
          name: record.label,
          value: record.total
        };
      }
    });
    return reportData;
  }
};

const GetAllReportColumns = (mapRegions, attributes) =>  {
    if (mapRegions) {
      let processedData: any[] = [], i = 1;
      let temp: any = {} as any, type = {"type": "string"};
      attributes.forEach(element => {
          if (element.type !== FormAttributeType.Description && element.type !== FormAttributeType.Int
          && element.type !== FormAttributeType.Point
          && !(element.input === FormAttributeInput.Text && element.type === FormAttributeType.Varchar)) {
              temp[element.label] = type;
          }
      });
      temp[FormFields.POSTID] = {"type": "number"};
      temp[FormFields.REGION] = type;
      temp[FormFields.ZONE] = type;
      // temp[FormFields.TYPE_OF_INCIDENT] = {...type, "hierarchy": FormFields.CLUSTERS};
      // temp[FormFields.INDICATORS] = {...type, "parent": FormFields.TYPE_OF_INCIDENT, "hierarchy": FormFields.CLUSTERS};;

      processedData.push(temp);
      for (let region in mapRegions) {
        let temp: any = {} as any;
        attributes.forEach(element => {
          if (element.type === FormAttributeType.Point) {
            temp[FormFields.REGION] = region;
          }
        });
        processedData.push(temp);
      };
      return processedData;
    }
}

const GetAllColumnData = (params) =>  {
    const {reportItem, tags, attributes, formId }  = params;
    let itemList = [];
    if (reportItem && reportItem !== undefined) {
      let individualItem: any = {};
        individualItem[FormFields.POSTID] = reportItem.id;
        if (formId === 1) {
          individualItem[FormFields.PRIORITY] = reportItem.priority;
          individualItem[FormFields.DATE] = moment(reportItem.post_date).format(environment.format.date);
        }
        individualItem[FormFields.TITLE] = reportItem.title;
        if (reportItem && !isEmpty(reportItem.mgmt_lev_1)) {
          individualItem[FormFields.REGION] = reportItem.mgmt_lev_1;
        }
        if (reportItem && !isEmpty(reportItem.mgmt_lev_2)) {
          individualItem[FormFields.ZONE] = reportItem.mgmt_lev_2;
        }
        if (reportItem && !isEmpty(reportItem.status)) {
          individualItem[FormFields.INCIDENT_STATUS] = (reportItem.status === 'draft') ? 'pending': reportItem.status;
        }

        if (reportItem && reportItem.values) {
          Object.keys(reportItem.values).map(category => {
            if (attributes && attributes.length > 0) {
              const keyFound = attributes.filter(item => {
              return item.key === category;
              });
              if (!isEmpty(keyFound)) {
                const val = reportItem.values[category][0];
                if (keyFound[0].type === 'tags') {
                  let temp = {
                    key: keyFound[0].label,
                    val: tags[val]
                  }
                  itemList.push(temp);
                } else {
                  individualItem[keyFound[0].label] = val;
                }
              }
            }
          });
        }
        let processedData = [];
        if (itemList && itemList.length === 0) {
          individualItem['Type of Incident'] = "";
          individualItem['Indicators'] = "";
          processedData.push(individualItem);
        } else {
          itemList.map((item) => {
            let temp = Object.assign({}, individualItem);
            temp['Type of Incident'] = item.key;
            temp['Indicators'] = item.val;
            temp[item.key] = item.val;
            processedData.push(temp);
          });
        }
      return processedData;
    }
}


const GetReport = (results, criteriaList, configAttributes: object) => {
  let allReports = [];
  if (results.length > 0) {
    results.forEach((value, index) => {
      if (value && criteriaList[index]) {
        let report: any = {};
        const metadata = CreateMetaData(criteriaList[index], configAttributes);
        report.title = metadata['title'];
        report.category = metadata['category'];
        if (value) {
          const reportType = parseInt(criteriaList[index]['format']);
          report.type = reportType;
          if (reportType && reportType === 1) {
            report.data = CreateTable(value);
          } else {
            report.data = CreateGraph(value, reportType);
          }
        }
        allReports.push(report);
      }
    });
    return allReports;
  }
};

const GetFilterLabels = (label: string, type:number = 0): string => {
  if (label) {
    switch (label) {
      case PostFilters.Incident_Status:
        if(type == 1){
          return 'FILTER_LABEL_STATUS';
        }else if(type == 2){
          return 'FILTER_LABEL_RISK_STATUS';
        }else{
          return 'FILTER_LABEL_STATUS';
        }
      case PostFilters.Priority:
        return 'FILTER_LABEL_PRIORITY';
      case PostFilters.Province:
        return 'FILTER_LABEL_MGMT_LEV_1';
      case PostFilters.District:
        return 'FILTER_LABEL_MGMT_LEV_2';
      case PostFilters.Department:
        return 'FILTER_LABEL_MGMT_LEV_3'
      case FormFilters.Target:
        return 'FILTER_LABEL_TARGET';
      case FormFilters.Status:
      return 'FILTER_LABEL_INCIDENT_STATUS';
      case FormFilters.Are_Womem_the_main_target:
      return 'FILTER_LABEL_ARE_WOMEN_TARGET';
      case FormFilters.Source_of_information:
      return 'FILTER_LABEL_SOURCE_OF_INFO';
      case FormFilters.Means:
      return 'FILTER_LABEL_MEANS';
      case FormFilters.Election_related:
      return 'FILTER_ELECTION_RELATED';
      case FormFilters.Incident_venue:
      return 'FILTER_INCIDENT_VENUE';
      case FormFilters.Perpetrators:
      return 'FILTER_ALLEGED_PERPETRATORS';
      case FormFilters.Second_Perpetrators:
      return 'FILTER_ALLEGED_SECOND_PERPETRATORS';
      case RiskFilters.CREDIBILITY_RISK:
      return 'FILTER_CREDIBILITY_RISK';
      case RiskFilters.IMPACT_RISK:
      return 'FILTER_IMPACT_RISK';
      case RiskFilters.LIKELIHOOD_RISK:
      return 'FILTER_LIKELIHOOD_RISK';
      case RiskFilters.RISK_TYPE:
      return 'FILTER_RISK_TYPE';
      case RiskFilters.STATGE_RISK:
      return 'FILTER_STATGE_RISK';
      case RiskFilters.TYPE_OF_LOCATION:
      return 'FILTER_TYPE_OF_LOCATION';
      case RiskFilters.PROVINCE:
      return 'FILTER_GENERAL_REGION';
      case RiskFilters.WARD:
      return 'FILTER_GENERAL_WOREDA';
      case RiskFilters.DISTRICT:
      return 'FILTER_GENERAL_ZONE';
      default: return '';
    }
  }
};

const GetEnumValues = (enumVal: any) => {
  if (enumVal) {
    let temp = [];
    Object.keys(enumVal).forEach((value) => {
      temp.push(enumVal[value]);
    });
    return temp;
  }
  return [];
};

const GetFilterOptionsByKey = (
  name: string,
  regions: object[],
  statusScheme: string = 'default'
): string[] => {

    let keys, values;
  switch (name) {
      case PostFilters.Incident_Status:
        keys =
          statusScheme === 'all'
            ? PostHelpers.GetAllWorkflowStatuses()
            : PostHelpers.GetStatusesForScheme(statusScheme);
        values = [];
        keys.forEach((item: PostStatus) => {
          const obj = {
            name: PostHelpers.GetStatusLabel(item),
            value: item
          }
          values.push(obj);
        });
        return values;
      case PostFilters.Priority:
        keys = [
          PostPriority.Low,
          PostPriority.Medium,
          PostPriority.High,
          PostPriority.Critical
        ];
        values = [];
        keys.forEach((item: PostPriority) => {
          const obj = {
            name: PostHelpers.GetPostPriorityLebel(item),
            value: item
          }
          values.push(obj);
        });
        return values;
      case PostFilters.Department:
        values = [];
        if (regions && typeof regions === 'object') {
          Object.keys(regions).forEach((item) => {
            const obj = {
              name: item,
              value: item
            }
            values.push(obj);
          });
        }
        return values;
      case PostFilters.District:
        return [];
      case PostFilters.Province:
        return [];
      default: return [];
    }
};

const GetTagsFilters = (elements): any => {
  let filters: FilterItem[] = [];
    if (elements && elements.length > 0) {
      elements.forEach((ele) => {
        const filterItem: FilterItem = {
          label: ele.label,
          queryParam: ele.key,
          values: [],
          type: 'tags',
          input: ele.input
        }
        filters.push(filterItem);
      });
    }
    return filters;
}

const GetFilters = (
  regions,
  type = 0,
  statusScheme: string = 'default'
): any => {
    let filters: FilterItem[] = [];
    const filterKeys = GetEnumValues(PostFilters);
    if (filterKeys && filterKeys.length > 0) {
      filterKeys.forEach((key) => {
        const filterItem: FilterItem = {
          label: GetFilterLabels(key,type),
          queryParam: key,
          values: GetFilterOptionsByKey(key, regions, statusScheme)
        }
        filters.push(filterItem);
      });
    }
    return filters;
};

const GetAllowedAttributes = [
  FormFields.DATE.toLowerCase(),
  FormFields.TYPE_OF_INCIDENT.toLowerCase(),
  FormFields.SOURCE_OF_INFO.toLowerCase(),
  FormFields.ARE_WOMEN_MAIN_TARGET.toLowerCase(),
  FormFields.TARGET.toLowerCase(),
  FormFields.PERPETRATORS.toLowerCase(),
  FormFields.MEANS.toLowerCase(),
  FormFields.STATUS.toLowerCase(),
  FormFields.POSTID.toLowerCase(),
];

const GetAllowedRiskAttributes = [
  "FILTER_CREDIBILITY_RISK",
  "FILTER_RISK_TYPE",
  "FILTER_TYPE_OF_LOCATION",
  "FILTER_LIKELIHOOD_RISK",
  "FILTER_IMPACT_RISK",
  "FILTER_STATGE_RISK",
  "FILTER_GENERAL_REGION",
  "FILTER_GENERAL_ZONE",
  "FILTER_GENERAL_WOREDA",
  "FILTER_LABEL_MGMT_LEV_1",
  "FILTER_LABEL_MGMT_LEV_2",
  "FILTER_LABEL_MGMT_LEV_3"
];
const GetDateFromObject = (datePassed: any) => {
  const { year, month, day } = datePassed;
  return moment(
      new Date(
        year +
          '-' +
          month +
          '-' +
          day
      )
    ).format(environment.format.mdY);
}

export const FilterHelpers = {
  GetStartEndDates,
  GetReport,
  GetPostRequestOptions,
  GetAllReportColumns,
  GetAllowedAttributes,
  GetFilters,
  GetFormattedMapData,
  GetAllColumnData,
  GetDateFromObject,
  GetFilterLabels,
  GetAllowedRiskAttributes,
  GetTagsFilters
};
